// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upselling-checkout-option[data-v-5949134e]{border-color:#2497ae}.upselling-checkout-option[data-v-5949134e] .variant-item__price{background-color:#2497ae}.marketing-hint__icon[data-v-5949134e]{filter:invert(45%) sepia(0) saturate(1%) hue-rotate(63deg) brightness(96%) contrast(98%);max-height:1.7em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
